import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate, useParams } from 'react-router-dom';
import PreviousAndNextButton from '../components/common/buttons/PreviousAndNextButton.jsx';
import { useFetchIllustrations } from '../hooks/useFetchIllustrations';

const ItemDetailsPage = () => {
  const [illustrations] = useFetchIllustrations();
  const { _illustrationId } = useParams();
  const navigate = useNavigate();

  if (illustrations.length === 0) return;

  const currentIndex = illustrations.findIndex(
    (illustration) => illustration._id === _illustrationId
  );

  const illustration = illustrations[currentIndex];
  const nextIndex = currentIndex + 1;
  const prevIndex = currentIndex - 1;

  const handleClose = () => {
    navigate('/', { viewTransition: true });
  };

  return (
    <div className="fixed inset-0 z-[9999] bg-white animate-in fade-in duration-200">
      <div className="relative w-full h-full flex flex-col bg-white animate-in zoom-in-95 duration-300">
        <button
          onClick={handleClose}
          className="absolute top-4 right-4 z-50 w-12 h-12 flex items-center justify-center"
          aria-label="Close viewer"
        >
          <FontAwesomeIcon icon={faXmark} className="text-[32px]" />
        </button>

        <div className="flex-1 flex flex-col items-center justify-center px-6 py-20 sm:px-12 overflow-y-auto overflow-hidden">
          <img
            alt={illustration.title}
            className="w-full h-auto max-h-[70vh] object-contain overflow-hidden"
            src={illustration.image}
          />
          <figcaption className="font-nunito font-light mt-2 text-sm text-center text-body">
            {illustration.title}
          </figcaption>
        </div>

        <div className="max-w-7xl mx-auto px-4 py-4">
          <PreviousAndNextButton
            nextIndex={nextIndex}
            prevIndex={prevIndex}
            illustrations={illustrations}
            currentIndex={currentIndex}
          />
        </div>
      </div>
    </div>
  );
};

export default ItemDetailsPage;
